module.exports = __webpack_public_path__ + "static/mcGOLD2-0012e14a55f53a264ef02ae6a5a359b9.png";